// accordion 
$(document).ready(function() {
//$('.accordion .heading').addClass('active');
//$('.accordion .contents').slideDown();
$('.accordion .heading').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.accordion .contents').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.accordion .contents').slideUp();
      $('.accordion .heading').removeClass('active');
      $(this).siblings('.accordion .contents').slideToggle();
      $(this).toggleClass('active');
    }
});     
});